<template>
<!--    <PlayerListItem v-for="p in fprofiles"-->
<!--                    :profile="p"-->
<!--                    :checks="creategroup"-->
<!--                    :checkon="selected[p.partkey]"-->
<!--                    @selected="emitSelected(p)"-->
<!--    />-->
    <v-list-item
            @click="HandleClick(profile)"
    >
        <v-list-item-avatar>
            <v-avatar>
                <v-img :src="profile.profilepic"></v-img>
            </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>
                {{profile.firstname}} {{profile.lastname}}  <v-icon small v-if="active" color="green">{{icons.checkon}}</v-icon>
            </v-list-item-title>
            <v-list-item-subtitle>
                PIN: {{profile.pin}} |
                <span class="black--text">{{profile.gradyear}}</span> |
                <span class="text-capitalize">{{profile.status}}</span> |
                <span class="" v-if="profile.active===1">Public</span><span v-else>Private</span>
                | <span :class="getColor(profile.paymentstatus)" v-if="profile.paymentstatus" >{{profile.paymentstatus}} </span>
            </v-list-item-subtitle>
            <Lbls>@/src/a4l/playercomponents/PlayerListItem</Lbls>
        </v-list-item-content>
        <v-list-item-action v-if="loading===profile.partkey">
            <v-btn loading text>L</v-btn>
        </v-list-item-action>
        <v-list-item-action v-if="checks">
            <v-icon v-if="checkon" color="blue">{{icons.checkon}}</v-icon>
            <v-icon v-else>{{icons.checkoff}}</v-icon>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Lbls from "@/components/Lbls";

  export default {
    name: "PlayerListItem",
    props:['profile','checks','checkon','islink','loading','active','paidstatus'],
    components: {Lbls},
    data() {
      return {}
    },
    computed: {
      ...mapState(['icons'])
    },
    methods: {
      ...mapActions(['get', 'post']),
      HandleClick(p){
        if(this.islink){
          this.$router.push('/myathletes/profile/'+p.partkey)
        }else{
          this.$emit('selected',p)
        }
      },
      getColor(status){
        if(status==='paid'){
          return 'text-capitalize green--text'
        }else if(status==='sent'){
          return 'text-capitalize red--text light--2'
        }else{
          return 'text-capitalize yellow--text'
        }
      }
    }
  }

</script>

<style scoped>

</style>